import React from "react";
import { TouchableOpacity } from "react-native";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { categoryIconMap } from "../../../constants/maps";
import { COLORS as DEFAULT_COLORS } from "../../theme/colors";
import { COLORS as APP_COLORS } from "../../../theme/colors";

const COLORS = { ...DEFAULT_COLORS, ...APP_COLORS };

/**
 * Checkbox component for the web platform.
 *
 * @param {Object} props - Props for the checkbox component.
 * @param {string} props.label - Label text for the checkbox.
 * @param {boolean} props.value - Checked state of the checkbox.
 * @param {Function} props.onChange - Callback for value change.
 * @param {string} props.color - Checked color.
 * @param {string} props.uncheckedColor - Unchecked color.
 * @returns {JSX.Element} A web-specific checkbox component.
 */
const CheckboxWeb = ({
  label,
  value = false,
  onChange,
  accessibilityLabel,
  accessibilityState,
  color = COLORS.primary,
  uncheckedColor = COLORS.border,
  testID="",
}) => {
  const id = `checkbox-${Math.random().toString(36).substring(2, 15)}`;
  const accessibilityLabelFinal = accessibilityLabel || `${label} ${value ? "checked" : "unchecked"}`;
  return (
    <div style={styles.container}>
      <label style={styles.checkboxLabel} htmlFor={id} data-testid={testID}>
        <input
          id={id}
          type="checkbox"
          checked={value}
          onChange={() => onChange(label)}
          style={styles.hiddenInput}
          aria-checked={accessibilityState?.checked || value}
          aria-label={accessibilityLabelFinal}
        />
        <span
          style={{
            ...styles.checkbox,
            backgroundColor: value ? color : "transparent",
            borderColor: value ? color : uncheckedColor,
          }}
        >
          {value && <FontAwesomeIcon aria-hidden="true" icon={faCheck} style={styles.checkmark} />}
        </span>
        {label && categoryIconMap[label] && (
          <FontAwesomeIcon aria-hidden="true" icon={categoryIconMap[label]} size="lg" color={COLORS.border} style={styles.categoryIcon} />
        )}
        {label && (
          <span
            style={{
              ...styles.label,
              userSelect: "none",
            }}
          >
            {label}
          </span>
        )}
      </label>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
  },
  hiddenInput: {
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
  },
  checkbox: {
    width: 20,
    height: 20,
    border: "2px solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: 4,
    transition: "all 0.2s ease-in-out",
  },
  checkboxLabel: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  categoryIcon: {
    marginLeft: 12,
    marginRight: 2,
  },
  checkmark: {
    color: COLORS.textLight,
    fontSize: 14,
  },
  label: {
    marginLeft: 8,
    fontSize: 16,
    color: COLORS.textDark,
    cursor: "pointer",
  },
};

export default CheckboxWeb;
